<template>
    <div class="checkout__accordion">
        <span class="checkout__accordion__title">{{ __('Summary') }}</span>

        <section class="checkout__box" style="margin: 30px 0;" v-if="website.ecommerce.discount_codes">
            <span class="checkout__box__ttl">{{ __('Discount Code') }}</span>

            <div class="checkout__event mt40">
                <form class="form" @submit.prevent="save">
                    <div class="wrapper">
                        <div class="row  row--reset">
                            <div class="col  col--9">
                                <div class="col__inner  col__inner--reset">
                                    <input type="text" id="discount" name="code" class="form__input  form__input--secondary" :placeholder="__('Enter discount code')" v-model="fields.code" />
                                </div>
                            </div>
                            <div class="col  col--3">
                                <div class="col__inner  col__inner--reset">
                                    <button class="button  btn  btn--tertiary" style="padding: 11px 0px; width: 100%; text-align: center;">{{ __('Apply') }}</button>
                                </div>
                            </div>
                        </div>
                        <div id="discount-message" class="row  row--reset mt20" v-if="discount_message"  :class="{success: discountSuccess, error: !discountSuccess}">
                            <div class="col  col--12">
                                <div class="col__inner  col__inner--reset">
                                    {{ discount_message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>

        <section class="checkout__box" v-if="website.protecht_public_key && order && order.id">
            <span class="checkout__box__ttl">{{ __('Order Protection') }}</span>

            <div class="checkout__event mt40">
                <protecht-widget
                    :order="order"
                    @order-updated="get"
                />
            </div>
        </section>

        <section id="section-payment" class="checkout__box">
            <span class="checkout__box__ttl">{{ __('Payment') }}</span>

            <div class="checkout__event mt40">
                <template v-if="!order.total">
                    <p>Due to your order total being zero, we do not need any payment details.</p>
                </template>
                <component
                    v-else-if="!loading"
                    :is="`app-gateway-${method}`"
                    :order="order"
                    :currency="order.currency"
                    :amount="order.amount"
                    :redirect-url="order.redirect_url"
                    :owner="owner"
                />
            </div>
        </section>

        <section class="section  section--primary" v-if="!order.total">
            <div class="section__inner  section__inner--quaternary">
                <div class="container">
                    <h2 class="title  title--primary" id="customer_details" v-if="method == 'paypal'">
                        <span class="title__inner  title__inner--primary">Customer Details</span>
                    </h2>
                    <div class="checkout__block">
                        <div v-if="method == 'paypal'">
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.name" placeholder="* Name" class="form__input form__input--secondary">
                                <p v-if="errors && errors.name" style="color: red">{{ errors.name[0] }}</p>
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.email" placeholder="* Email" class="form__input form__input--secondary">
                                <p v-if="errors && errors.email" style="color: red">{{ errors.email[0] }}</p>
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.telephone" placeholder="* Telephone" class="form__input form__input--secondary">
                                <p v-if="errors && errors.telephone" style="color: red">{{ errors.telephone[0] }}</p>
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.line_1" placeholder="Address Line 1" class="form__input form__input--secondary">
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.county" placeholder="County" class="form__input form__input--secondary">
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.city" placeholder="City" class="form__input form__input--secondary">
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.postcode" placeholder="Postcode" class="form__input form__input--secondary">
                            </div>
                            <div class="form__field">
                                <input type="text" v-model="delivery_details.country" placeholder="Country" class="form__input form__input--secondary">
                            </div>
                            <div class="form__field">
                                <label>
                                    <input type="checkbox" v-model="terms_agreed"> I agree with the  <a target="_blank" href="/terms-and-conditions">terms &amp; conditions</a>
                                </label>
                                <div class="form__error" v-if="terms_agreed_error">
                                    <p>You must agree with the spectator code of conduct</p>
                                </div>
                            </div>
                        </div>
                        <div class="checkout__btn">
                            <button type="button" class="button btn btn--quaternary" @click="completeFreeOrder()">Complete order</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PayPal from './Gateway/PayPal';
    import Stripe from './Gateway/Stripe';
    import Stripedirectdebit from './Gateway/Stripedirectdebit';
    import PayStack from './Gateway/PayStack';
    import Offline from './Gateway/Offline';
    import Pos from './Gateway/Pos';

    export default {
        components: {
            'app-gateway-stripe': Stripe,
            'app-gateway-stripedirectdebit': Stripedirectdebit,
            'app-gateway-paypal': PayPal,
            'app-gateway-paystack': PayStack,
            'app-gateway-offline': Offline,
            'app-gateway-pos': Pos,
        },

        props: {
            completed: {
                type: Boolean,
                required: true
            },
            ticket: {
                type: String,
                required: true
            },
            method: {
                type: String,
                required: true
            }
        },

        data: () => ({
            website: window.website,
            fields: {
                code: ''
            },
            delivery_details: {
                name: '',
                email: '',
                telephone: '',
                line_1: '',
                county: '',
                city: '',
                postcode: '',
                country: ''
            },
            terms_agreed: false,
            terms_agreed_error: false,
            errors: {},
            order: {},
            summary: '',
            discounts: true,
            discount_message: '',
            discountSuccess: false,
            loading: false,
            protechtQuoteToken: null,
        }),

        mounted() {
            this.setLoading(true);

            this.get().then(() => {
                return this.check();
            }).then(() => {
                this.setLoading(false);
            });
        },

        methods: {
            setLoading( value ) {
                this.$emit('loading', value);
                this.loading = value;
            },
            save() {
                this.setLoading(true);

                return axios.post('/checkout/discount', {
                    code: this.fields.code
                }).then(response => {
                    this.discount_message = response.data.message;
                    this.discountSuccess = response.data.success;
                    return this.get();
                }).then(() => {
                    this.setLoading(false);
                });
            },

            get() {
                return axios.get('/checkout/summary').then(response => {
                    this.summary = response.data.html;
                    this.order   = response.data.order;
                    if (this.order && (this.order.discount_percentage || this.order.discount_amount)) {
                      this.discounts = false;
                    }
                });
            },

            check() {
                return axios.get('/checkout/discounts').then(response => {
                    this.discounts = response.data.discounts;
                });
            },

            completeFreeOrder() {
                if (this.method != 'paypal') {
                    return axios.post('/booking/free', {
                        bypass: 1
                    }).then(response => {
                        window.location.href = response.data;
                    });
                }

                this.terms_agreed_error = false;
                if (!this.terms_agreed) {
                    this.terms_agreed_error = true;
                    return false;
                }

                return axios.post('/booking/free', {
                    name: this.delivery_details.name,
                    email: this.delivery_details.email,
                    telephone: this.delivery_details.telephone,
                    line_1: this.delivery_details.line_1,
                    county: this.delivery_details.county,
                    town: this.delivery_details.town,
                    postcode: this.delivery_details.postcode,
                    country: this.delivery_details.country
                }).then(response => {
                    window.location.href = response.data;
                }).catch(error => {
                    this.errors = error.response.data.errors;
                    document.getElementById("customer_details").scrollIntoView();
                    this.setLoading(false);
                });
            },
            setProtechtQuoteToken(token){
                this.protechtQuoteToken = token;
            }
        },

        computed: {
            owner() {
                return {
                    name: this.order.billing_name || '',
                    email: this.order.billing_email || '',
                    phone: this.order.billing_telephone || '',
                    address: {
                        line1: this.order.billing_address_1 || '',
                        line2: this.order.billing_address_2 || '',
                        city: this.order.billing_town || '',
                        state: this.order.billing_county || '',
                        postal_code: this.order.billing_postcode || '',
                        country: 'GB'
                    }
                }
            }
        },

        watch: {
        }
    }
</script>
<style scoped lang="scss">
#discount-message {
    &.success {
        // color: rgb(28, 185, 99);
    }
    &.error {
        color: rgb(185, 28, 28);
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Summary.vue